





























import { Component, Prop, Vue } from 'vue-property-decorator'
import { SelectMode } from './SectionPlayerList.vue'
import { GamePlayer } from '@/class/gamePlayer'

@Component
export default class ProclaimPoliceArea extends Vue {
  @Prop() playerSelf!: GamePlayer
  @Prop() selectMode!: SelectMode

  get isTurnEnded () {
    return this.playerSelf.turnEnd
  }

  get isProclaimMafiaMode() {
    return this.selectMode === SelectMode.proclaimIsMafia
  }

  get isProclaimNotMafiaMode() {
    return this.selectMode === SelectMode.proclaimIsNotMafia
  }

  changeModeProclaimMafia() {
    if (this.selectMode === SelectMode.proclaimIsMafia) {
      this.$emit('changeSelectMode', SelectMode.default)
    } else {
      this.$emit('changeSelectMode', SelectMode.proclaimIsMafia)
    }
  }

  changeModeProclaimNotMafia() {
    if (this.selectMode === SelectMode.proclaimIsNotMafia) {
      this.$emit('changeSelectMode', SelectMode.default)
    } else {
      this.$emit('changeSelectMode', SelectMode.proclaimIsNotMafia)
    }
  }
}
